<template>
  <PieChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    class="make-a-copy"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import PieChart from '@/components/cards/models/PieChart';
import { mapActions, mapGetters } from 'vuex';
import { OPERATION, POST_FIELDS } from '@/services/charts-service';
import EventBus from '@/utils/event-bus';
import cardsModel from '@/mixins/cards-model';

export default {
  name: 'ThemeSharePieChart',
  components: {
    PieChart,
  },
  mixins: [
    cardsModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
    };
  },
  computed: {
    ...mapGetters('dashboard', ['activeDashboardFilters', 'activeGlobalFilter']),
    series() {
      return this.extractDataForPieChart();
    },
  },
  watch: {
    activeDashboardFilters: {
      deep: true,
      handler() {
        this.getData();
      },
    },
    activeGlobalFilter: {
      deep: true,
      handler() {
        this.getData();
      },
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', ['getChartsService']),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getChartsService({
        itemId: this.itemId,
        method: 'getAggregatedData',
        points_parser: 'points',
        params: {
          grouping: [POST_FIELDS.THEME],
          operators: OPERATION.COUNT,
          datePortion: this.getDatePortion(options),
        },
      })
        .then((response) => {
          this.rawSeries = response?.points || [];
          this.requestStatus = 'success';
          if (this.$attrs.filter) {
            this.filter = this.$attrs.filter;
          }

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch((err) => {
          console.error(err);
          this.requestStatus = 'error';
        });
    },
    extractDataForPieChart() {
      const filterValues = this.$attrs.filter?.themes?.value || this.activeGlobalFilter?.themes?.value;
      let filteredData = this.rawSeries;
      if (filterValues) {
        filteredData = this.rawSeries.filter(item => filterValues.includes(item.x));
      }

      return filteredData.map(item => ({
        name: item.x,
        y: item.z,
      }));
    },
  },
};
</script>
